'use strict';

const $ = jQuery.noConflict();

const renderMap = {

	$domMap: null,
	map: null,
	zoomBackup: null,
	centerBackup: null,
	infoWindow: null,

	init: (locations) => {
		renderMap.initDom();
		renderMap.initMap();
		renderMap.renderPins(locations);
	},

	initDom: () => {
		renderMap.$domMap = $('.js-map');
	},

	initMap: () => {
		const mapOptions = {
			center: {lat: 44.7866, lng: 20.4489},
			zoom: 10,
			clickableIcons: false,
			styles: renderMap.getMapStyle(),
			mapTypeControl: false,
			streetViewControl: false,
		};

		// eslint-disable-next-line no-undef
		renderMap.map = new google.maps.Map(renderMap.$domMap[0], mapOptions);
	},

	renderPins: (locations) => {
		if (!Array.isArray(locations) || locations.length === 0) {
			// eslint-disable-next-line
			renderMap.map.setCenter({ lat: 40.7128, lng: -74.0060 }); // New York
			renderMap.map.setZoom(12);
			return;
		}

		// eslint-disable-next-line
		const bounds = new google.maps.LatLngBounds();
		// eslint-disable-next-line
		renderMap.infoWindow = new google.maps.InfoWindow();
		const isMobile = window.innerWidth <= 992;
		const iconUrl = isMobile
			? window.fwsLocalized.themeRoot + '/src/assets/images/location-dot-mobile.svg'
			: window.fwsLocalized.themeRoot + '/src/assets/images/location-dot.svg';
		locations.forEach((location) => {
			const position = {
				lat: parseFloat(location.lat),
				lng: parseFloat(location.lng),
			};

			// eslint-disable-next-line
			const marker = new google.maps.Marker({
				position: position,
				map: renderMap.map,
				title: location.title || '',
				icon: iconUrl
			});

			bounds.extend(position);

			marker.addListener('click', () => {
				renderMap.zoomBackup = renderMap.map.getZoom();
				renderMap.centerBackup = renderMap.map.getCenter();

				const targetZoom = 16;
				renderMap.map.panTo(marker.getPosition());

				const zoomIn = () => {
					const currentZoom = renderMap.map.getZoom();
					if (currentZoom < targetZoom) {
						renderMap.map.setZoom(currentZoom + 1);
						setTimeout(zoomIn, 150);
					} else {
						renderMap.infoWindow.setContent(location.popup);
						renderMap.infoWindow.open(renderMap.map, marker);
					}
				};

				zoomIn();
			});

			renderMap.infoWindow.addListener('closeclick', () => {
				if (renderMap.zoomBackup && renderMap.centerBackup) {
					renderMap.map.panTo(renderMap.centerBackup);

					let currentZoom = renderMap.map.getZoom();

					const smoothZoomOut = () => {
						if (currentZoom > renderMap.zoomBackup) {
							currentZoom -= 2.2;
							renderMap.map.setZoom(currentZoom);
							requestAnimationFrame(smoothZoomOut);
						} else {
							renderMap.map.setZoom(renderMap.zoomBackup);
						}
					};

					smoothZoomOut();
				}
			});
		});

		renderMap.map.fitBounds(bounds);

		// eslint-disable-next-line
		const listener = google.maps.event.addListener(renderMap.map, 'idle', function() {
			if (renderMap.map.getZoom() > 15) {
				renderMap.map.setZoom(15);
			}
			// eslint-disable-next-line
			google.maps.event.removeListener(listener);
		});
	},

	getMapStyle: () => {
		return [
			{
				'featureType': 'landscape',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#fef8f2'
					}
				]
			},
			{
				'featureType': 'landscape',
				'elementType': 'geometry.stroke',
				'stylers': [
					{
						'color': '#fef8f2'
					}
				]
			},
			{
				'featureType': 'landscape',
				'elementType': 'labels',
				'stylers': [
					{
						'color': '#9e9e9e'
					}
				]
			},
			{
				'featureType': 'poi',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#d6d6d6'
					}
				]
			},
			{
				'featureType': 'poi',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#757575'
					}
				]
			},
			{
				'featureType': 'poi.business',
				'stylers': [
					{
						'visibility': 'off'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#ffffff'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [
					{
						'color': '#ffffff'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'labels.icon',
				'stylers': [
					{
						'visibility': 'off'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#757575'
					}
				]
			},
			{
				'featureType': 'road.highway',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#f3b21b'
					}
				]
			},
			{
				'featureType': 'transit',
				'stylers': [
					{
						'visibility': 'off'
					}
				]
			},
			{
				'featureType': 'water',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#bfecff'
					}
				]
			},
			{
				'featureType': 'water',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#ebebeb'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'labels',
				stylers: [{visibility: 'on'}]
			},
			{
				featureType: 'administrative',
				elementType: 'labels',
				stylers: [{visibility: 'on'}]
			},
		];
	},

};

export default renderMap;
